import Imageviewer from "./Imageviewer";

export default Imageviewer;



// WEBPACK FOOTER //
// ./src/components/image-viewer/index.tsx